import { Bike } from 'models/shared';

export const serializeBike = (bike: Bike) => {
  const make = typeof bike.make === 'string' ? bike.make : String(bike.make);
  const model =
    typeof bike.model === 'string' ? bike.model : String(bike.model);
  return `${bike.year}:${encodeURIComponent(make)}:${encodeURIComponent(
    model
  )}`;
};

export const deserializeBike = (str: string): Bike | null => {
  const parts = str.split(':');
  if (parts.length < 3) return null;
  const [year, make, model] = parts;
  const yearNum = Number(year);
  if (
    !yearNum ||
    typeof make !== 'string' ||
    typeof model !== 'string' ||
    isNaN(yearNum)
  )
    return null;
  return {
    year: yearNum,
    make: decodeURIComponent(make) as Bike['make'],
    model: decodeURIComponent(model),
  };
};
